/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * State of a submission
 */
export type ModuleSubmissionState = (typeof ModuleSubmissionState)[keyof typeof ModuleSubmissionState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleSubmissionState = {
  draft: 'draft',
  processing: 'processing',
  submitted: 'submitted',
  graded: 'graded',
  aborted: 'aborted',
} as const;
